import { Component, Input, OnInit } from '@angular/core'
import { GeneralService } from 'src/app/services/general/general.service'
import { LocaleService } from 'src/app/services/locale/locale-service'
import { environment } from 'src/environments/environment'

export type FooterMode = 'light' | 'dark'

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  constructor(private generalService: GeneralService, private localeService: LocaleService) { }

  @Input() logo = 'assets/icons/icon-logo-white.png'
  @Input() mode: FooterMode = 'light'
  isApp = this.generalService.isApp
  isKo = this.localeService.isKo
  ngOnInit(): void { }

  onClickIntroduce(): void {
    this.generalService.openInappBrowser(environment.externalLink.base)
  }

  onClickFaq(): void {
    this.generalService.openInappBrowser(environment.externalLink.faq)
  }

  onClickLogo(): void {
    location.replace(`${environment.webUrl}`)
  }
}
